import { render, staticRenderFns } from "./MyWorkflowTasks.vue?vue&type=template&id=4e9f60f1"
import script from "./MyWorkflowTasks.vue?vue&type=script&lang=js"
export * from "./MyWorkflowTasks.vue?vue&type=script&lang=js"
import style0 from "./MyWorkflowTasks.vue?vue&type=style&index=0&id=4e9f60f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports